export default "__VITE_ASSET__kfXXAMh0__"